import { render } from "./FranchiseKpi.vue?vue&type=template&id=0f82c43e&scoped=true"
import script from "./FranchiseKpi.vue?vue&type=script&lang=js"
export * from "./FranchiseKpi.vue?vue&type=script&lang=js"

import "./FranchiseKpi.vue?vue&type=style&index=0&id=0f82c43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f82c43e"]])

export default __exports__